import { useContext } from 'react';

import { AppConfigContext } from '../providers/AppConfigProvider';

export function useAppConfig() {
  const context = useContext(AppConfigContext);
  if (context === null) {
    throw new Error(
      'useAppConfig has to be used within <AppConfigContext.Provider>'
    );
  }
  return context;
}
